import { redirect } from "react-router-dom";
import { Role, User } from "../../auth/types/interfaces";
import { successResponse } from "../constants";
import { isPreProdEnvironment } from "../../environmentInfo/EnvironmentInfo";
import { getUserClaimCategories } from "../../auth/claimCategoryUtils";

/**
 * Loader for the Landing Page route. The landing page is shown when:
 * - User has the admin/PM role (WC_CLAIM_PRODUCT_GROUP), OR
 * - User has roles spanning 2+ distinct claim type categories
 *
 * Users with roles in only one category (including multiple country variants
 * of the same claim type) are redirected to the root route, which routes
 * them to their appropriate claim form via CheckRolesLoader.
 */
export const loader = async (user: User) => {
  // Admins always have access to the landing page, even in production
  if (user.roles?.includes(Role.WC_CLAIM_PRODUCT_GROUP)) {
    return successResponse();
  }

  // Block landing page in production for non-admin users for now -
  // redirect to root for CheckRolesLoader to handle routing
  if (!isPreProdEnvironment()) {
    return redirect("/");
  }

  if (getUserClaimCategories(user.roles).size >= 2) {
    return successResponse();
  }

  return redirect("/");
};
